/*
  RPECK 21/04/2025 - Variant picker change URL
  --
  Added to give us the ability to change the URL to a different product if the colour option was changed
*/
document.addEventListener('DOMContentLoaded', function(){

  // RPECK 21/04/2025 - Get a list of the colour blocks
  document.querySelectorAll('form.shopify-product-form').forEach(function(item){

    // RPECK 21/04/2025 - If they change
    item.addEventListener('product:rerender', function(e){

      // RPECK 21/04/2025 - Get the variant info
      var variantText = document.querySelector('script[data-variant]')?.textContent || "{}";

      // RPECK 21/04/2025 - Convert to JSON
      var variantInfo = JSON.parse(variantText);

      // RPECK 21/04/2025 - Check to see if variantInfo is present
      if(
        Object.keys(variantInfo).length !== 0 &&
        'linkedProduct' in variantInfo        &&
        variantInfo['linkedProduct'] !== '/products/'
      ) {

          // RPECK 21/04/2025 - If linkedProduct exists, redirect to it
          window.location = variantInfo['linkedProduct'];
        
      }
      
    });
    
  });
  
});

// RPECK 07/05/2025 - Tabs update function
// Used by the RPECK tabs blocks - these are loaded dynamically and the JS doesn't carry through
window.update_tabs = function(e) {
  
  // RPECK 07/05/2025 - Get the selector from the input
  // The input provides a data-selector value which we can use to apply the 'active' class
  let active_selector = e.dataset.selectors;

  // RPECK 07/05/2025 - Only proceed if the active_selector variable is present
  // Ensures we're able to allocate the active class to any of the items required
  if(active_selector) {

    document.querySelectorAll(`.tabbed-block ~ *:not(${active_selector})`).forEach(function(item){
      item.classList.remove('active');
    });
    
    document.querySelectorAll(`.tabbed-block ~ ${active_selector}`).forEach(function(item){
      item.classList.add('active');
    });

  }
  
}

// RPECK 07/05/2025 - Start by showing the page
document.addEventListener('tab_change', function(){

  // RPECK 07/05/2025 - Get the first tab
  let tab = document.querySelector('.rpeck-tabbed-content input:checked');

  // RPECK 07/05/2025 - Run the tab if it's present
  if(tab) window.update_tabs(tab);
  
});

// RPECK 06/01/2025 - Size Guide in Fit Tab
document.addEventListener('DOMContentLoaded', function(event){
  document.querySelector('a[href="#size-guide"]')?.addEventListener('click', function(e){
    e.preventDefault();
    document.querySelector('button.sizeguide')?.click();
  });
});